// Серверные функции для поиска (без React хуков)
import { SearchResult, SearchOptions } from './types';
import { SearchService } from './searchService';

/**
 * Серверная функция для поиска товаров
 * Используется в серверных компонентах Next.js
 */
export async function searchItemsServer(
  options: SearchOptions,
  category: string,
  query: string
): Promise<SearchResult> {
  try {
    const searchService = new SearchService(options);
    const result = await searchService.searchItems(category, query);
    return result;
  } catch (error) {
    console.error('Server Search Error:', error);
    return {
      item: [],
      totalItems: 0,
      error: error instanceof Error ? error.message : 'Ошибка поиска'
    };
  }
}

/**
 * Создает экземпляр SearchService для переиспользования
 */
export function createSearchService(options: SearchOptions) {
  return new SearchService(options);
}
